import React, { useContext, useEffect } from "react";

//imagenes
import logo from "../assets/img/ebusinesslogo.svg";
import logomovil from "../assets/img/logomovil.svg";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import ConexContext from "../context/ConexContext";
import cerrarsesion2 from "../assets/img/cerrarsesion_blanco.svg";
import { NavLink, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { ReactComponent as UsuariosIcon } from "../assets/img/usuarios.svg";
import { ReactComponent as DepartamentosIcon } from "../assets/img/departamentos.svg";
import { ReactComponent as TarjetasIcon } from "../assets/img/tarjetas.svg";
import { ReactComponent as DashboardIcon } from "../assets/img/home-icon.svg";


//Contexto

const Layout = ({ setmensaje2 }) => {
	let navigate = useNavigate();
	// CONEX
	const { setToken, getToken, id_usuario, tipo_usuario } =
		useContext(ConexContext);

	//Abrir y cerrar barra lateral
	const sidebarCollapse = () => {
		document.getElementById("sidebar").classList.toggle("active");
		document.getElementById("content").classList.toggle("active");
		document.getElementById("sidebaricon").classList.toggle("cambiaicono");
	};

	//Cerrar sesion y borrar token
	function cerrarSesion() {
		setToken("");
		localStorage.removeItem("token");
		setmensaje2("La sesión se ha cerrado correctamente.");
		navigate("/");
	}

	// hace el set de los datos del usuario
	useEffect(() => {
		setToken(getToken());
		// eslint-disable-next-line
	}, []);

	// RETURN
	return (
		<>
			<div className="wrapper">
				<div id="content">
					<div className="section_login">
						<div className="content_app fadeInDown">
							<div className="col-xs-12 logo">
								<img src={logo} alt="" />
							</div>

							<div className="app fixpadding col-xs-12 filadatos">
								<Outlet />
							</div>
						</div>
					</div>
				</div>
				{/*sidebar*/}
				<nav id="sidebar" className="col-xs-12">
					<div
						className="navbar navbar-expand-lg"
						id="sidebaricon"
						onClick={sidebarCollapse}
					></div>
					<div className="flex-vertical">
						<div className="col-xs-12 logotipo bdbotoom logomovil">
							<img src={logomovil} alt="logo ceca" />
						</div>
						<ul className="nav-items">
							<li>
								<NavLink
									to="/listado"
									onClick={sidebarCollapse}
									className={({ isActive }) =>
										isActive ? "nav-link active" : "nav-link"
									}
								>
									<span>
										Dashboard
									</span>
									<DashboardIcon />
								</NavLink>
							</li>
							{(tipo_usuario === "5" ||
								tipo_usuario === "2" ||
								tipo_usuario === "0" ||
								tipo_usuario === "3") && (
								<li>
									<NavLink
										to="/administracion/usuarios"
										onClick={sidebarCollapse}
										className={({ isActive }) =>
											isActive ? "nav-link active" : "nav-link"
										}
									>
										<span>
											Usuarios
										</span>
										<UsuariosIcon />
									</NavLink>
								</li>
							)}
							{(tipo_usuario === "5" ||
								tipo_usuario === "2" ||
								tipo_usuario === "0" ||
								tipo_usuario === "3") && (
								<li>
									<NavLink
										to="/administracion/departamentos"
										onClick={sidebarCollapse}
										className={({ isActive }) =>
											isActive ? "nav-link active" : "nav-link"
										}
									>
										<span>
											Departamentos
										</span>
										<DepartamentosIcon />
									</NavLink>
								</li>
							)}
							{(tipo_usuario === "5" ||
								tipo_usuario === "2" ||
								tipo_usuario === "0" ||
								tipo_usuario === "3") && (
								<li>
									<NavLink
										to="/administracion/tarjetas"
										onClick={sidebarCollapse}
										className={({ isActive }) =>
											isActive ? "nav-link active" : "nav-link"
										}
									>
										<span>
											Tarjetas
										</span>
										<TarjetasIcon />
									</NavLink>
								</li>
							)}
							{/* <li>
								<NavLink
									to={"/perfil/" + id_usuario}
									onClick={sidebarCollapse}
									className={({ isActive }) =>
										isActive ? "nav-link active" : "nav-link"
									}
								>
									Mi Cuenta
								</NavLink>
							</li> */}
						</ul>
					</div>
					<div className="col-xs-12 contnav_sidebar nopadding">
						<ul>
							<li className="current-user">
								<NavLink
									to={"/perfil/" + id_usuario}
									onClick={sidebarCollapse}
									className={({ isActive }) =>
										isActive ? "nav-link perfil" : "nav-link perfil"
									}
								>
									{id_usuario}
								</NavLink>
							</li>
							<li>
								<button
									id="button_azul_menu"
									className="cerrarsesion"
									onClick={() => cerrarSesion()}
								>
									Cerrar sesión
									<span>
										<img src={cerrarsesion2} alt="cerrar sesión" />
									</span>
								</button>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</>
	);
};

export default Layout;
